import type { AnnounceDetail as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

/**
 * The slice of the announce record read outside the announce screens themselves.
 *
 * Each consumer selects only what it needs, so a field is `undefined` both when the record
 * lacks it and when the query didn't ask for it: the event list fragments select `announceAt`
 * only, while the order-detail query selects `promoter`/`support` only.
 */
export type EventAnnounceSummary = {
  announceAt?: string;
  promoter?: string;
  support?: string;
};

export const fromGql = (item: GQLItem): EventAnnounceSummary =>
  take<EventAnnounceSummary>(item, 'announceAt', 'promoter', 'support');
